import React from "react";
import "./PageIndicator.css";

const PageIndicator = ({ currentPage, totalPages }) => {
    return (
        <div className="page-indicator">
            {Array.from({ length: totalPages }, (_, index) => (
                <div
                    key={index}
                    className={`page-dot ${index === currentPage ? 'active' : ''}`}
                />
            ))}
            <span className="page-text">
                {currentPage + 1} of {totalPages}
            </span>
        </div>
    );
};

export default PageIndicator;
